import { inject, Injectable } from '@angular/core';
import { Observable, of, tap, from, catchError } from 'rxjs';
import { CoresService } from './cores.service';
import { ArcAngelNotificationsService } from './arc-angel-notification.service';
import { ArcAngelMonitorModeService } from '../../components/shared/arc-angel-monitor-mode.service';
import * as Cesium from 'cesium';
import CesiumNavigation from 'cesium-navigation-es6';
import { ArcAngelPlaybackModeService } from './arc-angel-playback-mode.service';
import { WindowService } from './window.service';
import { CameraService } from './camera.service';
import { ArcAngelService } from './arc-angel.service';
import { SessionOptionsService } from './session-option.service';
import { ArcAngelLiveModeService } from './arc-angel-live-mode.service';
import { OrganizationUtilService } from './organization-util.service';
import { TimelineService } from './timeline.service';
import { CdrGlobeService } from './cdr-globe.service';
@Injectable({
  providedIn: 'root',
})
export class ArcAngelModesService {
  private core = inject(CoresService);
  currentMode: string | undefined;
  currentModeEventType: string | undefined;
  buildingRows: any[] = [];
  constructor(
    private arcAngelNotificationsService: ArcAngelNotificationsService,
    private arcAngelMonitorModeService: ArcAngelMonitorModeService,
    private arcAngelPlaybackService: ArcAngelPlaybackModeService,
    private windowService: WindowService,
    private cameraService: CameraService,
    private sessionOptionsService: SessionOptionsService,
    private arcAngelService: ArcAngelService,
    private arcAngelLiveModeService: ArcAngelLiveModeService,
    private orgUtilService: OrganizationUtilService,
    private timelineService: TimelineService,
    private cdrGlobeService: CdrGlobeService
  ) { }

  resetArcAngelService(
    mode: string,
    eventId: string,
    eventType: string,
    showPinDialog: boolean,
    scope: any,
    suppressReset?: boolean
  ) {
    // Initialize Cesium navigation if in monitor mode

    if (mode === 'Monitor Mode' && !this.core.getViewer()?.cesiumNavigation) {
      const viewer = this.core.getViewer();
      const userOrgId = (localStorage.getItem('PAA_org') ?? '').trim();
      if (userOrgId === '2025') {
        this.cdrGlobeService.flyToNigeria();
      } else {
        const campusRows = this.orgUtilService.data?.myCampus?.campuses || [];
        const buildingRows = this.orgUtilService.buildingRows || [];
        const campusId = campusRows[0]?.campusId;
        if (campusRows.length >= 1) {
          const coords = campusRows[0]?.campusPosition?.coordinates;
          if (coords?.length === 2) {
            const destination = Cesium.Cartesian3.fromDegrees(
              coords[0],
              coords[1],
              5000
            );

            this.cameraService.flyTo({
              destination,
              complete: () => {
                const building = this.orgUtilService.data?.myBuildings?.find(
                  (b: any) => Number(b.perimeterId) === Number(campusId)
                );
                const entity = building?.pin;
                entity?.viewDetailsWindow?.(entity);
              },
            });
          }
        } else if (buildingRows.length === 1) {
          const coords = buildingRows[0]?.position?.coordinates;
          if (coords?.length === 2) {
            const destination = Cesium.Cartesian3.fromDegrees(
              coords[0],
              coords[1],
              500
            );

            this.cameraService.flyTo({
              destination,
              complete: () => {
                const entity =
                  this.orgUtilService.data?.myBuildings?.[0]?.pin;
                entity?.viewDetailsWindow?.(entity);
              },
            });
          }
        } else if (viewer && !viewer.cesiumNavigation) {
          this.cameraService.flyHome(1);
        }
      }
    }

    this.currentMode = mode;
    this.currentModeEventType = eventType;

    // Close all map entity detail windows  To - DO Below code

    this.windowService.closeAllMapEntityDetailsWindow();

    // Handle different modes
    switch (mode) {
      case 'Monitor Mode':
        this.arcAngelMonitorModeService.startMonitorMode();
        this.arcAngelPlaybackService.stopPlaybackMode();
        this.arcAngelLiveModeService.stopLiveMode();
        return this.setupMonitorMode().pipe(
          tap(() => {
            // this.timelineService.setTimelineByMode(MONITOR_MODE);
          })
        );

      case 'LIVE_MODE':
        // this.router.navigate(['/live']); // Alternative to $broadcast
        if (eventType === 'INCIDENT') {
          // return this.setupLiveIncident(
          //   eventId,
          //   showPinDialog,
          //   scope,
          //   suppressReset
          // );
        } else if (eventType === 'PROCALL' || eventType === 'TRACKING') {
          return;
          // return this.setupLiveTrackingAndProcall(
          //   eventId,
          //   showPinDialog,
          //   scope
          // );
        }
        console.error('Unrecognized live mode option');
        return of(undefined);

      case 'PLAYBACK_MODE':
        if (eventType === 'INCIDENT') {
          return this.setupPlaybackIncident(eventId, scope);
        } else if (eventType === 'PROCALL') {
          return this.setupPlaybackProcall(eventId);
        } else if (eventType === 'CALENDAR') {
          return this.setupPlaybackCalendar(eventId);
        } else if (eventType === 'TRACKING') {
          return this.setupPlaybackTracking(eventId);
        }

        return of(undefined);

      case 'PROJECT_MODE':
        return;
      // return this.setupProjectMode().pipe(
      //   tap(() => {
      //   })
      // );

      case 'Flight Mode':
        return;
      // return this.setupFlightMode().pipe(
      //   tap(() => {
      //   })
      // );

      default:
        return of(undefined);
    }
  }

  startArcAngelService(
    mode: string,
    eventId: string,
    eventType: string,
    scope: any
  ): Observable<any> {
    this.currentMode = mode;
    this.currentModeEventType = eventType;
    try {
      // Start forever poller 
      switch (mode) {
        case 'Monitor Mode':
          return this.setupMonitorMode().pipe(
            tap(() => { })
          );
        //this.timelineService.setTimelineByMode('MONITOR_MODE');

        case 'LIVE_MODE':
          switch (eventType) {
            case 'INCIDENT':
              this.setupLiveIncident(eventId, true, scope);
              return of(undefined);
            case 'PROCALL':
            case 'TRACKING':
              this.setupLiveTrackingAndProcall(eventId, true, scope);
              return of(undefined);
            default:
              throw new Error('Unrecognized live mode option');
          }

        case 'PLAYBACK_MODE':
          switch (eventType) {
            case 'INCIDENT':
              return this.setupPlaybackIncident(eventId, scope);
            case 'PROCALL':
              return this.setupPlaybackProcall(eventId);
            case 'CALENDAR':
              return this.setupPlaybackCalendar(eventId);
            case 'TRACKING':
              return this.setupPlaybackTracking(eventId);
            default:
              throw new Error('Unrecognized playback mode option');
          }

        case 'PROJECT_MODE':
          return of(undefined);

        default:
          return of(undefined);
      }

      // Set user info from ArcAngel service

      // this.sessionOptionsService.setEmail(this.arcAngelService.myEmail);
      // this.sessionOptionsService.setOrganizationName(this.arcAngelService.myFirstOrg.title);
      // this.sessionOptionsService.setFullName(this.arcAngelService.myName);

      // Start notifications service
      //await this.arcAngelNotificationsService.startNotificationsService(scope);
    } catch (error) {
      console.error('Error starting arc angel polling:', error);
      throw error;
    }
  }

  // Add any helper methods needed...
  private setupMonitorMode(this: any): Observable<any> {
    return this.arcAngelMonitorModeService.startMonitorMode().pipe(
      tap(result => {
        if (result) {
        }
        //this.arcAngelNotificationsService.startNotificationsService(scope);
      })
    );
  }
  private async setupLiveTrackingAndProcall(
    eventId: string,
    showPin: boolean,
    scope: any
  ): Promise<void> {
    // Implement tracking and procall setup
  }

  private async setupLiveIncident(
    eventId: string,
    showPin: boolean,
    scope: any
  ): Promise<void> {
    // Implement live incident setup
  }

  private setupPlaybackIncident(
    eventId: string,
    scope: any
  ): Observable<any> {
    this.timelineService.setTimelineByMode('PLAYBACK_MODE');
    this.arcAngelService.hideNonBuildingPerimeters();
    this.arcAngelService.clearPerimeters();

    this.arcAngelMonitorModeService.stopMonitorMode();
    this.arcAngelPlaybackService.stopPlaybackMode();
    this.arcAngelLiveModeService.stopLiveMode();

    return from(this.arcAngelPlaybackService.startIncidentPlaybackMode(eventId, scope)).pipe(
      catchError(error => {
        console.error('Error starting incident playback mode.', error);
        throw error;
      })
    );
  }

  private setupPlaybackProcall(
    eventId: string
  ): Observable<any> {
    this.timelineService.setTimelineByMode('PLAYBACK_MODE');
    this.arcAngelService.hideNonBuildingPerimeters();
    this.arcAngelService.clearPerimeters();

    this.arcAngelMonitorModeService.stopMonitorMode();
    this.arcAngelPlaybackService.stopPlaybackMode();
    this.arcAngelLiveModeService.stopLiveMode();

    return from(this.arcAngelPlaybackService.startProcallPlaybackMode(eventId, null)).pipe(
      catchError(error => {
        console.error('Error starting procall playback mode.', error);
        throw error;
      })
    );
  }

  private setupPlaybackCalendar(
    eventId: string
  ): Observable<any> {
    this.timelineService.setTimelineByMode('PLAYBACK_MODE');
    this.arcAngelService.hideNonBuildingPerimeters();
    this.arcAngelService.clearPerimeters();

    this.arcAngelMonitorModeService.stopMonitorMode();
    this.arcAngelPlaybackService.stopPlaybackMode();
    this.arcAngelLiveModeService.stopLiveMode();

    return of(undefined);
  }

  private setupPlaybackTracking(
    eventId: string
  ): Observable<any> {
    this.timelineService.setTimelineByMode('PLAYBACK_MODE');
    this.arcAngelService.hideNonBuildingPerimeters();
    this.arcAngelService.clearPerimeters();

    this.arcAngelMonitorModeService.stopMonitorMode();
    this.arcAngelPlaybackService.stopPlaybackMode();
    this.arcAngelLiveModeService.stopLiveMode();

    return of(undefined);
  }
  async switchToLiveProcallMode(id: string, byPassPin: boolean = false): Promise<void> {
    await this.arcAngelService.establishIncidentOrgForLiveMode(id);

    if (byPassPin) {
      this.sessionOptionsService.goToLiveProcallMode(id, true);
      return;
    }

    const options = { eventType: 'OPERATE_ACTIVE_INCIDENT', eventId: id }; // Replace with PinActivationDialogOptions if you have a class
    const result = await this.windowService.openModalWindow(
      options,
      'PinActivationDialogController',
      'components/arcangel/views/pin-activation-dialog.html'
    );

    if (result === 'ACTIVATE_AND_GO') {
      this.sessionOptionsService.goToLiveProcallMode(id, true);
    }
  }
  async switchToLiveTrackingMode(id: string, byPassPin: boolean = false): Promise<void> {
    await this.arcAngelService.establishIncidentOrgForLiveMode(id);

    if (byPassPin) {
      this.sessionOptionsService.goToLiveTrackingMode(id, true);
      return;
    }
    const options = { eventType: 'OPERATE_ACTIVE_INCIDENT', eventId: id }; // Use PinActivationDialogOptions if available
    const result = await this.windowService.openModalWindow(
      options,
      'PinActivationDialogController',
      'components/arcangel/views/pin-activation-dialog.html'
    );

    if (result === 'ACTIVATE_AND_GO') {
      this.sessionOptionsService.goToLiveTrackingMode(id, true);
    }
  }
}
